export const FETCH_CURRENT_TIME = 'FETCH_CURRENT_TIME'
export const FETCH_CURRENT_TIME_SUCCESS = 'FETCH_CURRENT_TIME_SUCCESS'

export const REMOVE_CURRENT_TIME = 'REMOVE_CURRENT_TIME'
